import { casingUtil } from '@/utils'

export const resolvePayoutDown = casingUtil.snakeToCamel
